import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchContactsFilterDependencies } from '../../../../actions/admin/models/contacts';
import SelectField from '../../../../components/forms/SelectField';
import { VALUE_ALL } from '../../../../constants/settings';
import { toSelectionFormat } from '../../../../lib/collection.utils';
import {
    fetchedDependenciesSelector,
    fetchingDependenciesSelector,
    dependenciesSelector
} from '../../../../selectors/admin/forms';
import { filtersSelector } from '../../../../selectors/admin/tables';
import { contextSubjectSelector } from '../../../../selectors/admin/context';
import { ALL_ORGS_CONTEXT } from '../../../../constants/admin/settings';

class ContactsEventFilter extends Component {
    componentDidMount() {
        this._fetchDependencies();
    }
    componentDidUpdate() {
        this._fetchDependencies();
    }
    _fetchDependencies() {
        if (
            this.props.contextId &&
            this.props.contextId != ALL_ORGS_CONTEXT.id &&
            !this.props.fetchedDependencies &&
            !this.props.fetchingDependencies
        ) {
            this.props.fetchContactsFilterDependencies(this.props.contextId);
        }
    }
    render() {
        const { filters = {}, contextId } = this.props;
        if (!contextId || contextId == ALL_ORGS_CONTEXT.id) {
            return null;
        }
        return (
            <div className="ckp-admin-search-form ckp-grid-row">
                <SelectField
                    onChange={this.props.updateFilter}
                    className="is-without-padding"
                    label="Event"
                    name="event"
                    items={[
                        { value: VALUE_ALL, label: 'All events' },
                        ...toSelectionFormat(this.props.dependencies.events)
                    ]}
                    value={filters.event || ''}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    contextId: contextSubjectSelector(state),
    dependencies: dependenciesSelector(state),
    filters: filtersSelector(state),
    fetchedDependencies: fetchedDependenciesSelector(state),
    fetchingDependencies: fetchingDependenciesSelector(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchContactsFilterDependencies }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContactsEventFilter);
